<template>
<div>
    <nav
      class="navbar md-down-fixed-top navbar-expand-md navbar-light bg-body pt-4 d-flex flex-column align-items-center"
    >
      <div class="container" style="height: 100%">
        <a class="navbar-brand d-flex flex-row align-items-center" href="/">
          <img
            :src="$store.state.brand.logo"
            class="d-inline-block align-top"
            :alt="$store.state.brand.name"
          >
          <span class="mobileHide">{{$store.state.campaign.name}}</span>
        </a>
        <div class="d-none d-md-flex">
          <ul class="navbar-nav ml-auto d-flex align-items-center">
            <li class="nav-item">
              <a class="nav-link">
                <div v-html="iconLogout" @click="$store.dispatch('logout'); $router.push('/')" class="ml-4 f-icon" style="line-height:1px;width:30px;cursor: pointer"></div>
              </a>
            </li>
          </ul>
        </div>
        <div class="d-flex d-md-none">
          <ul class="navbar-nav ml-auto d-flex">
            <a class="nav-item nav-link">
              <i class="fal fa-cog" style="font-size: 1.5rem;"></i>
            </a>
          </ul>
        </div>
      </div>
    </nav>
    <nav class="nav nav-pills nav-fill fixed-bottom d-md-none w-100 flex-nowrap" id="bottomBar">
      <a class="nav-item nav-link">
        <i class="fal fa-home"></i>
        {{$t('tenants.home')}}
      </a>
      <a class="nav-item nav-link">
        <i class="fal fa-chart-bar"></i>
        {{$t('tenants.leaderboard')}}
      </a>
      
      <a class="nav-item nav-link">
        <div v-html="iconMgm" style="line-height:1px;"></div>
          {{$t('Invite')}}
      </a>
    </nav>
    <main class="actions">
        <div class="col-12 col-md-8 m-auto">
                <h2 class="text-center mb-5">{{$t('You Need to agree with privacy terms')}}</h2>
                <form data-vv-scope="agreementsForm"
                    @submit.prevent="validateForm('agreementsForm', saveAgreements)">
                    <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="agreements.tos" name="tos" id="tos" ref="tos" v-validate="'required'">
                            <label class="form-check-label" for="tos">
                                Ho preso visione, compreso e accetto i <a href="/info/tos" target="_blank">Termini di servizio</a>
                            </label>
                            <span v-show="errors.has('agreementsForm.tos')" class="invalid-feedback" style="position: relative; bottom: 0px; padding-bottom: 10px;">
                                <strong>{{ errors.first('agreementsForm.tos') }}</strong>
                            </span>
                        </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="privacy" id="privacy" ref="privacy"  v-model="agreements.privacy" v-validate="'required'">
                        <label class="form-check-label" for="privacy">
                            {{$t('Agree with privacy terms')}}
                        </label>
                        <span v-show="errors.has('agreementsForm.privacy')" class="invalid-feedback" style="position: relative; bottom: 0px; padding-bottom: 10px;">
                            <strong>{{ errors.first('agreementsForm.privacy') }}</strong>
                        </span>
                    </div>
                    <div class="form-check">
                            <input class="form-check-input" type="checkbox" name="marketing" id="marketing" ref="marketing" v-model="agreements.marketing">
                            <label class="form-check-label" for="marketing">
                                {{$t('Agree with marketing terms')}}
                            </label>
                        </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="profilation" ref="profilation" id="profilation"  v-model="agreements.profilation">
                        <label class="form-check-label" for="profilation">
                            {{$t('Agree with profilation terms')}}
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="third" id="third" ref="third" v-model="agreements.third">
                        <label class="form-check-label" for="third">
                            {{$t('Agree with third party marketing terms')}}
                        </label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="third_profilation" id="third_profilation" ref="third_profilation" v-model="agreements.third_profilation">
                        <label class="form-check-label" for="third_profilation">
                            {{$t('Agree with third party profilation terms')}}
                        </label>
                    </div>
                    
                    <div class="form-group col-12 text-center mt-5">
                        <button type="submit" class="btn btn-primary btn-lg">
                            {{ $t('Submit') }}
                        </button>
                    </div>
                </form>
            </div>
    </main>
</div>
</template>
<script>
import iconMgm from './../assets/svg/fnz_mgm.svg';
import iconLogout from './../assets/svg/fnz_logout.svg'
export default {
  name: "agreements",
  data: function() {
    return {
      agreements: {
          tos: false,
          privacy: false,
          marketing: false,
          profilation: false,
          third: false,
          third_profilation: false
      },
      iconLogout: iconLogout
    };
  },
  methods: {
      saveAgreements() {
          this.$http
        .post(
          "/api/v1/campaigns/" +
            this.$store.state.campaign.id +
            "/users/agreements", {
                agreements: this.agreements
            }
        ).then((response) => {
            this.$store.dispatch("getUserInfo").then((response) => {
              this.$router.push('/dashboard')
            })
        }).catch((err) => {
            this.$store.commit("pushMessage", {
            type: "waiting",
            title: "Something went wrong",
            text: "Please retry"
          });
        })
      }
  },
  components: {
    iconLogout
  }
};
</script>